module.exports = __webpack_public_path__ + "static/media/buildingConstruction22.ccb82932.jpg";